import NavMenu from '../../components/navbar/NavMenu'
import TitleBar from '../../components/navbar/TitleBar'
import RoleMain from '../../components/role/RoleMain'
import Footer from '../../components/common/Footer'
export default function RolePage() {
  return (
    <>
            <TitleBar />
            <NavMenu />
            <RoleMain/>
            <Footer/>
        </>
  )
}
